import { CheckoutApiResponse, EnrollmentOrderDetails } from '@/types/joinUsType';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type EnrollmentCheckout = {
  completeOrderSummary?: CheckoutApiResponse;
  summary?: EnrollmentOrderDetails;
  token?: string;
};

const initialState = {
  completeOrderSummary: {} as CheckoutApiResponse,
  summary: {} as EnrollmentOrderDetails,
} as EnrollmentCheckout;

const enrollmentCheckout = createSlice({
  name: 'enrollmentCheckout',
  initialState,
  reducers: {
    setEnrollmentOrderSummary: (state, { payload }: PayloadAction<CheckoutApiResponse>) => {
      state.completeOrderSummary = payload;
    },

    setUpdateOrderSummary: (state, { payload }: PayloadAction<EnrollmentOrderDetails>) => {
      state.summary = payload;
    },
    setToken: (state, { payload }: PayloadAction<string | undefined>) => {
      state.token = payload;
    },
  },
});

export const { setEnrollmentOrderSummary, setUpdateOrderSummary, setToken } = enrollmentCheckout.actions;
export default enrollmentCheckout;
